import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import AppNavbar from "../../components/common/AppNavbar";

const SouthAfricaImmigrationGuidelines = () => {
  const categories = [
    {
      name: "Apply for Visa (VFS Global)",
      link: "https://visa.vfsglobal.com/zaf/en",
    },
    {
      name: "Tourist Visa",
      link: "https://www.southafrica-visa.com/tourist-visa",
    },
    {
      name: "Business Visa",
      link: "https://www.southafrica-visa.com/business-visa",
    },
    {
      name: "Work Visa",
      link: "https://www.southafrica-visa.com/work-visa",
    },
    {
      name: "Student Visa",
      link: "https://www.southafrica-visa.com/student-visa",
    },
    {
      name: "Relative’s Visa",
      link: "https://www.southafrica-visa.com/relatives-visa",
    },
    {
      name: "Retirement Visa",
      link: "https://www.southafrica-visa.com/retirement-visa",
    },
    {
      name: "Permanent Residency",
      link:
        "https://www.dha.gov.za/index.php/immigration-services/permanent-residency",
    },
    {
      name: "Citizenship",
      link: "https://www.dha.gov.za/index.php/civic-services/citizenship",
    },
  ];

  return (
    <>
      <AppNavbar />
      <Container fluid className="my-4">
        <Row>
          <Col lg={9}>
            <h4 className="my-4 fw-bold">
              General Guidance on South Africa Immigration and Visas
            </h4>
            <ul>
              <li>
                <b>Visa Types:</b>
                <ul>
                  <li>
                    <b>Short-Stay Visas (up to 90 days):</b> Tourist, Business,
                    Transit, Medical Treatment, Cultural/Sports/Conference
                    Visas.
                  </li>
                  <li>
                    <b>Long-Stay Visas (Temporary Residence):</b> Work Visa
                    (General, Critical Skills, Intra-Company Transfer), Study,
                    Relative’s, Retirement, Business, and Permanent Residency
                    Permit.
                  </li>
                </ul>
              </li>
              <li>
                <b>Requirements:</b> Valid passport (30+ days beyond stay, 2
                blank pages), application form, photos, proof of accommodation,
                travel itinerary, proof of funds, medical/radiology reports
                (long-stay), police clearance (long-term), and purpose-specific
                documents (job contract, admission letter, business plan, etc.).
              </li>
              <li>
                <b>Application Process:</b>
                <ul>
                  <li>Determine visa type based on purpose.</li>
                  <li>
                    Submit application at South African Embassy/Consulate or VFS
                    Global.
                  </li>
                  <li>Provide biometrics if required.</li>
                  <li>
                    Processing: Short-term visas 5–15 days; long-term 8–12
                    weeks.
                  </li>
                  <li>Collect visa/permit once approved.</li>
                </ul>
              </li>
              <li>
                <b>Tips for Success:</b> Apply 4–8 weeks in advance,
                certify/translate documents, ensure employer/institution
                recognition, track application via VFS, and consider legal help
                for permanent residency.
              </li>
              <li>
                <b>Helpful Resources:</b>{" "}
                <a
                  href="https://www.dha.gov.za"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Department of Home Affairs (South Africa)
                </a>
                ,{" "}
                <a
                  href="https://visa.vfsglobal.com/zaf/en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  VFS Global South Africa
                </a>
                .
              </li>
            </ul>

            <Row className="g-0">
              {categories.map((category, index) => (
                <Col
                  lg={4}
                  key={index}
                  className="d-flex align-items-center p-2 border rounded shadow-sm bg-light hover-effect"
                >
                  <a
                    href={category.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {category.name}
                  </a>
                </Col>
              ))}
            </Row>

            <div className="text-center py-4">
              <h6 style={{ fontSize: "11px" }}>ADVERTISEMENT</h6>
              <div className="text-center">
                {/* Mobile: Display Image 1 */}
                <Row className="d-md-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Maroon+traditional+Minimal+Guru+Purnima+Greeting+Instagram+Post.gif"
                      alt="Mobile"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Tablet: Display Image 2 */}
                <Row className="d-none d-md-flex d-lg-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
                      alt="Tablet"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Desktop: Display Image 3 */}
                <Row className="d-none d-lg-flex">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
                      alt="Desktop"
                      className="img-fluid"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>

          <Col lg={3} md={3}>
            <div className="d-flex justify-content-center">
              <small>Advertisement</small>
            </div>

            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block pt-2 border"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Maroon+traditional+Minimal+Guru+Purnima+Greeting+Instagram+Post.gif"
                fluid
              />
            </Link>
            <Link to="https://forms.gle/YZ8rr4Dzpwi4R3An7">
              <Image
                className="mx-auto d-block pt-2"
                src="https://ayg.s3.us-east-2.amazonaws.com/bharat/Beige+and+Brown+Illustrative+Krishna+Janmashtami+Greeting+Instagram+Post+(1).gif"
                fluid
              />
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SouthAfricaImmigrationGuidelines;
